import { render, staticRenderFns } from "./storyboard.vue?vue&type=template&id=7c200c85&"
import script from "./storyboard.vue?vue&type=script&lang=js&"
export * from "./storyboard.vue?vue&type=script&lang=js&"
import style0 from "./storyboard.vue?vue&type=style&index=0&id=7c200c85&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports